import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// Lives in its own leaf module so museumCanvas.js can use it without pulling in
// clsx/tailwind-merge, which a plain ESM preview page cannot resolve.
export { isRoamSource } from "./sources"